import Swal from "sweetalert2";

export function build_company_profile_form_data(vm) {
  vm.description = vm.$refs.quill_company_editor_ref.getHTML();

  const form_data = new FormData();
  const fields = get_company_profile_form_fields(vm);

  Object.entries(fields).forEach(([key, value]) => {
    form_data.append(key, value ?? "");
  });

  return form_data;
}

function get_company_profile_form_fields(vm) {
  return ({
    base_profile_id: vm.base_profile_id,
    company_name: vm.company_name,
    type_of_organization_id: vm.selected_type_of_organization,
    description: vm.description,
    email: vm.email,
    tell_number: vm.tell_number,
    location: vm.location,
    street_address: vm.address_list.street_address,
    suburb: vm.address_list.suburb,
    town: vm.address_list.town,
    province: vm.address_list.province,
    postal_code: vm.address_list.postal_code,
  });
}

export function show_company_update_loader() {
  return Swal.fire({
    title: "Updating...",
    text: "Please wait while we update the company profile.",
    allowOutsideClick: false,
    didOpen: () => Swal.showLoading(),
  });
}

export function show_company_profile_alert(title, text, icon, timer = 3000) {
  return Swal.fire({
    title,
    text,
    icon,
    timer,
    position: "bottom-end",
    toast: true,
    showConfirmButton: false,
  });
}

export function confirm_company_profile_action(
  title,
  text,
  confirm_button_text = "Confirm"
) {
  return Swal.fire({
    title,
    text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: confirm_button_text,
    position: "bottom-end",
    toast: true,
  });
}
